export const formatCurrency = (num: number | null, includeCents: boolean = false) => {
	if (num === null || num === undefined) return 'N/A';
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: includeCents ? 2 : 0
	}).format(num);
};

export const formatNumber = (num: number | null, numDecimals: number = 0) => {
	if (num === null || num === undefined) return 'N/A';
	return new Intl.NumberFormat('en-US', {
		minimumFractionDigits: numDecimals
	}).format(num);
};

export const formatDate = (date: string | null) => {
	if (!date) return 'N/A';
	return new Intl.DateTimeFormat('en-US').format(new Date(date));
};

export const formatPercentage = (num: number | null, numDecimals: number = 0) => {
	if (num === null || num === undefined) return 'N/A';
	return new Intl.NumberFormat('en-US', {
		style: 'percent',
		minimumFractionDigits: numDecimals
	}).format(num);
};
